import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const usePlanStore = create(
  persist(
    (set) => ({
      currentPlan: null,
      savedPlans: [],
      isGenerating: false,
      error: null,
      subscriptionTier: 'free',
      plansRemaining: 2,
      
      setCurrentPlan: (plan) => set({ currentPlan: plan }),
      setSavedPlans: (plans) => set({ savedPlans: plans }),
      setIsGenerating: (isGenerating) => set({ isGenerating }),
      setError: (error) => set({ error }),
      setSubscription: (tier, remaining) => set({ subscriptionTier: tier, plansRemaining: remaining }),
      clearCurrentPlan: () => set({ currentPlan: null }),
      
      // Add plan to saved
      addSavedPlan: (plan) => set((state) => ({
        savedPlans: [plan, ...state.savedPlans.filter(p => p.id !== plan.id)]
      })),
      
      // Remove from saved
      removeSavedPlan: (planId) => set((state) => ({
        savedPlans: state.savedPlans.filter(p => p.id !== planId)
      })),
    }),
    {
      name: 'panchi-plan-store',
      partialize: (state) => ({ savedPlans: state.savedPlans }),
    }
  )
);

export const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      sessionToken: null,
      loading: false,
      needsOnboarding: false,
      
      setUser: (user) => set({ user, loading: false }),
      setSessionToken: (token) => set({ sessionToken: token }),
      setLoading: (loading) => set({ loading }),
      setNeedsOnboarding: (needs) => set({ needsOnboarding: needs }),
      
      isAuthenticated: () => !!get().user,
      
      logout: () => {
        set({ user: null, sessionToken: null, needsOnboarding: false });
        localStorage.removeItem('panchi-auth-store');
      },
      
      completeOnboarding: () => set({ needsOnboarding: false }),
    }),
    {
      name: 'panchi-auth-store',
    }
  )
);
